import request from "../../../../../../utils/api";

export const getBranchTransactions = params => request(`branches/${params.id}/transactions`, { params });



